/* ==========================================================================
   EDME — Global Product Card Behaviors
   --------------------------------------------------------------------------
   Swatch (renk) tıklama, beden tıklama ve kart içi görsel carousel mantığını
   SAYFADAKİ TÜM .edme-pcard kartlarına bağlar — koleksiyon section'ına bağımlı
   değildir. Böylece renk kutucukları sadece koleksiyon grid'inde değil; tablı
   carousel, genel carousel, "son gezilenler" ve ARAMA (predictive search)
   sonuçları gibi her yerde KOLEKSİYONDAKİYLE BİREBİR çalışır:
     - Renk seçilince carousel, o rengin TÜM görselleriyle (data-swatch-images,
       '|' ayrılmış) yeniden kurulur; tek görsel varsa (data-swatch-image) tek
       fotoğraf gösterilir; ürünün kendi (varsayılan) rengine dönülünce orijinal
       galeri geri yüklenir.
     - Masaüstü: görselin üstünde yatay hover-scrub. Mobil: touch swipe.
     - Dot tıklama + (varsa) ok tuşları. Görünürlük .is-active + inline display.

   Çakışma güvenliği:
     - Renk/beden için koleksiyon JS'i (edme-main-collection.js) ile AYNI bayrağı
       (dataset.edmeSwBound) paylaşır; carousel için aynı bayrağı (__edmeColCarousel)
       kullanır → hangi dosya önce yakalarsa o bağlar, diğeri atlar (çift bağlama yok).

   Kurulum: bu dosyayı assets'e ekle ve theme.liquid'de </body>'den hemen önce:
     <script src="{{ 'edme-product-card.js' | asset_url }}" defer="defer"></script>
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     GÖRSEL ÖN-YÜKLEME (warming)
     Renk görsellerini tık öncesi sessizce indirir → farklı renge basınca
     görseller cache'ten anında gelir (geç yükleme biter).
       - Hover (masaüstü) / touchstart / focus: o rengin TÜM görselleri ısınır.
       - Kart viewport'a girince: her rengin İLK görseli ısınır (ilk tık da hızlı).
     window.__edmePreloaded ile global tekilleştirme: aynı URL bir kez indirilir,
     bu dosya ile koleksiyon dosyası aynı kayıt defterini paylaşır.
     ---------------------------------------------------------------------- */
  var EDME_PRELOADED = (window.__edmePreloaded = window.__edmePreloaded || {});
  function edmePreload(url) {
    if (!url || EDME_PRELOADED[url]) return;
    EDME_PRELOADED[url] = true;
    var im = new Image();
    try { im.decoding = 'async'; } catch (e) {}
    im.src = url;
  }
  function edmeSwatchUrls(sw) {
    var multi = sw.getAttribute('data-swatch-images');
    var single = sw.getAttribute('data-swatch-image');
    var urls = [];
    if (multi) {
      urls = multi.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (!urls.length && single) urls = [single];
    return urls;
  }
  var edmeWarmIO = null;
  function edmeEnsureWarmIO() {
    if (edmeWarmIO || !('IntersectionObserver' in window)) return edmeWarmIO;
    edmeWarmIO = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.querySelectorAll('.edme-pcard__swatch').forEach(function (sw) {
          var urls = edmeSwatchUrls(sw);
          if (urls.length) edmePreload(urls[0]);
        });
        obs.unobserve(en.target);
      });
    }, { rootMargin: '300px 0px' });
    return edmeWarmIO;
  }
  function edmeWarmSwatches(card) {
    if (!card || card.__edmeWarmBound) return;
    card.__edmeWarmBound = true;
    var sws = Array.prototype.slice.call(card.querySelectorAll('.edme-pcard__swatch'));
    if (!sws.length) return;
    sws.forEach(function (sw) {
      var warm = function () {
        var urls = edmeSwatchUrls(sw);
        for (var i = 0; i < urls.length; i++) edmePreload(urls[i]);
      };
      sw.addEventListener('mouseenter', warm);
      sw.addEventListener('touchstart', warm, { passive: true });
      sw.addEventListener('focus', warm);
    });
    var io = edmeEnsureWarmIO();
    if (io) io.observe(card);
  }

  /* ----------------------------------------------------------------------
     ÜRÜN KARTI: renk (swatch) + beden
     (koleksiyon JS'i ile aynı bayrağı paylaşır → çift bağlamaz)
     ---------------------------------------------------------------------- */
  function bindSwatchSize(card) {
    if (card.dataset.edmeSwBound === '1') return;
    card.dataset.edmeSwBound = '1';

    var primaryImg = card.querySelector('[data-pcard-primary]');
    var colorNameEl = card.querySelector('[data-pcard-color-label]');
    var sizesContainer = card.querySelector('[data-pcard-sizes]');
    var fallbackUrl = card.getAttribute('data-product-url');

    var swatches = card.querySelectorAll('.edme-pcard__swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');

        var newImg = sw.getAttribute('data-swatch-image');
        var colorName = sw.getAttribute('data-color-value') || '';

        if (newImg) {
          var targetImg = primaryImg;
          if (!targetImg) {
            targetImg = card.querySelector('.edme-pcard__slide.is-active img')
              || card.querySelector('.edme-pcard__slide img')
              || card.querySelector('.edme-pcard__img');
          }
          if (targetImg) {
            targetImg.removeAttribute('srcset');
            targetImg.src = newImg;
          }
        }

        if (colorNameEl && colorName) {
          colorNameEl.textContent = colorName.toLowerCase();
        }
      });
    });

    if (sizesContainer) {
      sizesContainer.querySelectorAll('.edme-pcard__size').forEach(function (sz) {
        sz.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (sz.disabled) return;
          var variantId = sz.getAttribute('data-variant-id');
          if (variantId && fallbackUrl) {
            var sep = fallbackUrl.indexOf('?') > -1 ? '&' : '?';
            window.location.href = fallbackUrl + sep + 'variant=' + variantId;
          }
        });
      });
    }
  }

  /* ----------------------------------------------------------------------
     ÜRÜN KARTI GÖRSEL CAROUSEL'İ
     - Masaüstü: hover-scrub (mouse'u sağa-sola gezdir → görsel + dot)
     - Mobil: touch swipe
     - Dot tıklama + ok tuşları
     - Renk swatch'ı → o rengin görselleriyle yeniden kurar / orijinale döner
     - Görünürlük .is-active sınıfı + inline display ile (CSS modeline bağımsız)
     ---------------------------------------------------------------------- */
  function initCarousel(card) {
    if (card.__edmeColCarousel) return;
    card.__edmeColCarousel = true;

    var media = card.querySelector('.edme-pcard__media');
    var track = card.querySelector('[data-pcard-track]');
    if (!media || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.edme-pcard__slide'));
    var slideCount = slides.length;

    var dots = Array.prototype.slice.call(card.querySelectorAll('[data-dot-index]'));
    var prevBtn = card.querySelector('[data-pcard-prev]');
    var nextBtn = card.querySelector('[data-pcard-next]');
    var link = card.querySelector('[data-pcard-link]');

    var dotsWrap = card.querySelector('[data-pcard-dots]');
    var index = 0;

    // Orijinal galeri (ürünün kendi rengi) — geri yükleme için sakla
    var originalTrackHTML = track.innerHTML;
    var originalDotsHTML = dotsWrap ? dotsWrap.innerHTML : null;
    var originalLinkHref = link ? link.getAttribute('href') : null;

    function buildSlidesHTML(urls) {
      return urls.map(function (u, i) {
        return '<div class="edme-pcard__slide' + (i === 0 ? ' is-active' : '') + '" data-slide-index="' + i + '">' +
          '<img class="edme-pcard__img' + (i === 0 ? ' edme-pcard__img--primary' : '') + '"' +
          (i === 0 ? ' data-pcard-primary' : '') +
          ' src="' + u + '" alt="" ' + (i === 0 ? 'loading="eager"' : 'loading="lazy"') + '>' +
        '</div>';
      }).join('');
    }
    function buildDotsHTML(n) {
      if (n <= 1) return '';
      var s = '';
      for (var i = 0; i < n; i++) {
        s += '<button type="button" class="edme-pcard__dot' + (i === 0 ? ' is-active' : '') +
             '" data-dot-index="' + i + '" aria-label="Görsel ' + (i + 1) + '"></button>';
      }
      return s;
    }

    function requery() {
      slides = Array.prototype.slice.call(track.querySelectorAll('.edme-pcard__slide'));
      slideCount = slides.length;
      dots = dotsWrap
        ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-dot-index]'))
        : Array.prototype.slice.call(card.querySelectorAll('[data-dot-index]'));
    }

    function bindDots() {
      dots.forEach(function (dot) {
        if (dot.__edmeDotBound) return;
        dot.__edmeDotBound = true;
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
          if (!isNaN(idx)) show(idx);
        });
      });
    }

    function preventGhostDrag() {
      track.querySelectorAll('img').forEach(function (img) {
        if (img.__edmeNoDrag) return;
        img.__edmeNoDrag = true;
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });
    }

    function show(i) {
      if (slideCount < 1) return;
      index = (i + slideCount) % slideCount;
      slides.forEach(function (s, k) {
        var on = (k === index);
        s.classList.toggle('is-active', on);
        // Görünürlüğü doğrudan JS yönetir (CSS .is-active'e slide görünürlüğü
        // bağlamayabilir): aktif görünür, diğerleri gizli.
        s.style.display = on ? '' : 'none';
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    }

    // Carousel'i verilen görsel listesiyle yeniden kurar (renk seçimi için)
    function applySet(urls, productUrl) {
      var list = (urls && urls.length) ? urls : [];
      if (!list.length) return;
      track.innerHTML = buildSlidesHTML(list);
      if (dotsWrap) dotsWrap.innerHTML = buildDotsHTML(list.length);
      if (link && productUrl) link.setAttribute('href', productUrl);
      requery();
      bindDots();
      preventGhostDrag();
      index = 0;
      show(0);
    }

    // Ürünün kendi (varsayılan) galerisine geri döner
    function restore() {
      track.innerHTML = originalTrackHTML;
      if (dotsWrap && originalDotsHTML != null) dotsWrap.innerHTML = originalDotsHTML;
      if (link && originalLinkHref != null) link.setAttribute('href', originalLinkHref);
      requery();
      bindDots();
      preventGhostDrag();
      index = 0;
      show(0);
    }

    // İlk durum
    requery();
    bindDots();
    preventGhostDrag();
    show(0);

    // --- Ok tuşları (CSS ile gizli olsalar da zarar vermez) ---
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); show(index - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); show(index + 1);
    });

    // --- RENK KUTUCUKLARI ↔ CAROUSEL ---
    // Bir renk seçilince carousel'i o rengin görselleriyle yeniden kurar:
    //   - data-swatch-images (çoklu, '|' ayrılmış) varsa → çoklu fotoğraf + kaydırma
    //   - sadece data-swatch-image (tek) varsa → tek fotoğraf
    //   - ürünün kendi (varsayılan) rengine dönülünce → orijinal galeri
    var swatches = Array.prototype.slice.call(card.querySelectorAll('.edme-pcard__swatch'));
    if (swatches.length) {
      var defaultSwatch = card.querySelector('.edme-pcard__swatch.is-active') || swatches[0];
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (sw === defaultSwatch) { restore(); return; }
          var productUrl = sw.getAttribute('data-product-url');
          var multi = sw.getAttribute('data-swatch-images');
          var single = sw.getAttribute('data-swatch-image');
          var urls = [];
          if (multi) {
            urls = multi.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
          }
          if (!urls.length && single) urls = [single];
          if (urls.length) applySet(urls, productUrl);
        });
      });
    }

    // --- MASAÜSTÜ: hover-scrub ---
    var finePointer = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      media.addEventListener('mousemove', function (e) {
        if (slideCount <= 1) return;
        var rect = media.getBoundingClientRect();
        if (rect.width <= 0) return;
        var x = e.clientX - rect.left;
        if (x < 0) x = 0;
        if (x > rect.width) x = rect.width;
        var zone = Math.floor((x / rect.width) * slideCount);
        if (zone >= slideCount) zone = slideCount - 1;
        if (zone !== index) show(zone);
      });
      media.addEventListener('mouseleave', function () {
        show(0);
      });
    }

    // --- MOBİL: touch swipe ---
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var isSwiping = false;

    media.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      touchEndX = touchStartX;
      isSwiping = false;
    }, { passive: true });

    media.addEventListener('touchmove', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var dx = Math.abs(touchEndX - touchStartX);
      var dy = Math.abs(e.changedTouches[0].screenY - touchStartY);
      if (dx > dy && dx > 10) isSwiping = true;
    }, { passive: true });

    media.addEventListener('touchend', function () {
      if (!isSwiping) return;
      var diff = touchStartX - touchEndX;
      var threshold = 40;
      if (diff > threshold) show(index + 1);
      else if (diff < -threshold) show(index - 1);
      isSwiping = false;
    }, { passive: true });

    // Sürükleme/swipe sırasında linke gitmeyi engelle
    if (link) {
      link.addEventListener('click', function (e) {
        if (isSwiping) {
          e.preventDefault();
          e.stopPropagation();
          isSwiping = false;
        }
      });
    }

    // Görselin tarayıcı "ghost drag"ini engelle
    media.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function initProductCard(card) {
    if (!card) return;
    bindSwatchSize(card);
    if (card.hasAttribute('data-pcard-carousel')) {
      initCarousel(card);
    }
    // Renk görsellerini tık öncesi ısıt — her kartta, hangi dosya bağlarsa bağlasın
    edmeWarmSwatches(card);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.edme-pcard').forEach(initProductCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Tema editöründe section yeniden yüklenince
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });

  // Dinamik kartlar (son gezilenler / sepete son eklenenler) sonradan basıldığında bağla
  // + Predictive search sonuçları (header.js → edme:search-results-rendered) sonradan basıldığında bağla
  function edmeBindRenderedCards(e) {
    var container = e && e.detail && e.detail.container;
    initAll(container || document);
  }
  document.addEventListener('edme:product-cards-rendered', edmeBindRenderedCards);
  document.addEventListener('edme:search-results-rendered', edmeBindRenderedCards);

  // Dışarıdan elle çağırmak isteyen olursa
  window.edmeInitProductCards = initAll;
})();